import { defineComponent as O, useSlots as G, useAttrs as J, useCssModule as K, ref as Q, computed as l, openBlock as m, createBlock as P, unref as r, normalizeClass as v, createSlots as W, withCtx as d, createElementVNode as z, withDirectives as N, createElementBlock as f, mergeProps as A, vModelText as X, vModelDynamic as Y, renderSlot as u, createCommentVNode as y } from "vue";
import Z from "../../utils/propValidator.mjs";
import _ from "../labelStandalone/CdrLabelStandalone.vue.mjs";
import ee from "../formError/CdrFormError.vue.mjs";
import re from "../../props/background.mjs";
import C from "../../utils/mapClasses.mjs";
import te from "../../utils/uid.mjs";
const oe = ["rows", "id", "disabled", "aria-required", "aria-invalid", "aria-errormessage", "aria-describedby"], ae = ["type", "disabled", "aria-required", "aria-invalid", "aria-errormessage", "aria-describedby"], le = ["id"], $ = "cdr-input", pe = /* @__PURE__ */ O({
  name: "CdrInput",
  inheritAttrs: !1,
  customOptions: {},
  __name: "CdrInput",
  props: {
    /**
     * Custom ID that is mapped to the label ‘for’ attribute. If this value is not set, it will be randomly generated.
     */
    id: {
      type: String
    },
    /**
     *  'type' attribute for the input as defined by w3c.
     *  Only supporting text|email|number|password|search|url|date|datetime-local.
     *  The increment/decrement webkit psuedo element is hidden for number.
     *  @demoSelectMultiple false
     *  @values text, email, number, password, search, url, tel, date, datetime-local
    */
    type: {
      type: [String],
      default: "text",
      validator: (e) => Z(e, ["text", "email", "number", "password", "search", "url", "tel", "date", "datetime-local"])
    },
    /**
     * Sets the text value for the input label. Required for a11y compliance. Use ‘hideLabel’ if the label display is not desired. Required.
    */
    label: {
      type: String,
      required: !0
    },
    /**
     * Sets default attributes for an input that should launch a numeric keyboard but is not strictly a 'number' (credit card, security code, postal code, etc.). Should be used in conjunction with the default text type input. An `input` listener can be used to fully restrict input values to numerical characters only
     */
    numeric: {
      type: Boolean,
      default: !1
    },
    /**
     * Removes the label element but sets the input `aria-label` to `label` text for a11y.
    */
    hideLabel: Boolean,
    /**
     * Number of rows for input. Converts component to text-area if rows greater than 1.
    */
    rows: {
      type: Number,
      default: 1
    },
    /**
     * Sets the background color the input is rendered on
     * @values primary, secondary
     */
    background: re,
    /**
     * Sets the input field size
    * @demoSelectMultiple true
    * @values large
    */
    size: String,
    /**
     * Sets the `role` attribute for the embedded error state messaging.
     */
    errorRole: {
      type: String,
      required: !1,
      default: "status"
    },
    /** Sets the input to an error state, displays the `error` slot if one is present. */
    error: {
      type: [Boolean, String],
      default: !1
    },
    /**
     * Sets the disabled state for the input field and label styling. Also, restricts user input.
     */
    disabled: Boolean,
    /**
     * Sets aria-required on the input field and displays an asterisk next to the input label.
     */
    required: Boolean,
    /**
     * Displays '(optional)' text next to the input label.
     */
    optional: Boolean,
    /** @ignore */
    modelValue: {
      type: [String, Number]
    },
    /** Adds a custom class to the cdr-label-standalone container div */
    inputContainerClass: String,
    /** Passes a custom class to the label for custom styles */
    labelClass: String
  },
  emits: {
    /**
    * Event emitted by v-model on the <input> element
    * @param modelValue
    */
    "update:modelValue": null
  },
  setup(e, {
    emit: F
  }) {
    const a = e, M = F, i = G(), g = J(), c = K(), p = Q(!1), E = i["helper-text-top"], L = i["helper-text-bottom"], h = i["pre-icon"], k = i["post-icon"], T = i["post-icon"] ? i["post-icon"]().length > 1 : !1, U = i.info, D = i["info-action"], s = a.id ? a.id : te(), H = l(() => a.rows > 1 ? "cdr-input--multiline" : ""), q = l(() => h ? "cdr-input--preicon" : ""), S = l(() => k ? "cdr-input--posticon" : ""), B = l(() => T ? "cdr-input--posticons" : ""), w = l(() => a.error ? "cdr-input--error" : ""), x = l(() => `cdr-input--${a.background}`), I = l(() => a.size ? `${$}--${a.size}` : ""), R = l(() => p.value ? "cdr-input--focus" : ""), V = l(() => {
      const t = [i["helper-text-top"] ? `${s}-helper-text-top` : "", i["helper-text-bottom"] ? `${s}-helper-text-bottom` : "", g["aria-describedby"]].filter((o) => o).join(" ");
      return a.error ? `${s}-error` : t;
    }), j = l(() => {
      const t = a.numeric || a.type === "number";
      return {
        id: s,
        autocomplete: "off",
        pattern: t ? "[0-9]*" : void 0,
        inputmode: t ? "numeric" : void 0,
        ...g
      };
    }), b = l({
      get() {
        return a.modelValue;
      },
      set(t) {
        M("update:modelValue", t);
      }
    });
    return (t, o) => (m(), P(_, {
      "for-id": r(s),
      label: e.label,
      "hide-label": e.hideLabel,
      required: e.required,
      optional: e.optional,
      disabled: e.disabled,
      class: v(e.inputContainerClass),
      "label-class": e.labelClass
    }, W({
      default: d(() => [z("div", {
        class: v(r(C)(r(c), "cdr-input-wrap", R.value))
      }, [e.rows && e.rows > 1 ? N((m(), f("textarea", A({
        key: 0,
        rows: e.rows,
        class: r(C)(r(c), $, H.value, q.value, S.value, B.value, w.value, x.value, I.value),
        id: r(s),
        disabled: e.disabled,
        "aria-required": e.required || void 0,
        "aria-invalid": !!e.error || void 0,
        "aria-errormessage": !!e.error && `${r(s)}-error` || void 0,
        "aria-describedby": V.value || void 0
      }, t.$attrs, {
        onFocus: o[0] || (o[0] = (n) => p.value = !0),
        onBlur: o[1] || (o[1] = (n) => p.value = !1),
        "onUpdate:modelValue": o[2] || (o[2] = (n) => b.value = n)
      }), null, 16, oe)), [[X, b.value]]) : N((m(), f("input", A({
        key: 1,
        type: e.type,
        class: r(C)(r(c), $, q.value, S.value, B.value, w.value, x.value, I.value),
        disabled: e.disabled,
        "aria-required": e.required || void 0,
        "aria-invalid": !!e.error || void 0,
        "aria-errormessage": !!e.error && `${r(s)}-error` || void 0
      }, j.value, {
        "aria-describedby": V.value || void 0,
        onFocus: o[3] || (o[3] = (n) => p.value = !0),
        onBlur: o[4] || (o[4] = (n) => p.value = !1),
        "onUpdate:modelValue": o[5] || (o[5] = (n) => b.value = n)
      }), null, 16, ae)), [[Y, b.value]]), r(h) ? (m(), f("span", {
        key: 2,
        class: v(r(c)["cdr-input__pre-icon"])
      }, [u(t.$slots, "pre-icon")], 2)) : y("", !0), r(k) ? (m(), f("span", {
        key: 3,
        class: v(r(c)["cdr-input__post-icon"])
      }, [u(t.$slots, "post-icon")], 2)) : y("", !0)], 2)]),
      _: 2
    }, [r(E) ? {
      name: "helper",
      fn: d(() => [u(t.$slots, "helper-text-top")]),
      key: "0"
    } : void 0, r(U) ? {
      name: "info",
      fn: d(() => [u(t.$slots, "info")]),
      key: "1"
    } : void 0, r(D) ? {
      name: "info-action",
      fn: d(() => [u(t.$slots, "info-action")]),
      key: "2"
    } : void 0, r(L) && !e.error ? {
      name: "helper-text-bottom",
      fn: d(() => [z("span", {
        id: `${r(s)}-helper-text-bottom`,
        class: v(r(c)["cdr-input__helper-text"])
      }, [u(t.$slots, "helper-text-bottom")], 10, le)]),
      key: "3"
    } : void 0, e.error ? {
      name: "error",
      fn: d(() => [e.error ? (m(), P(ee, {
        key: 0,
        error: e.error,
        role: e.errorRole,
        id: `${r(s)}-error`
      }, {
        error: d(() => [u(t.$slots, "error")]),
        _: 3
      }, 8, ["error", "role", "id"])) : y("", !0)]),
      key: "4"
    } : void 0]), 1032, ["for-id", "label", "hide-label", "required", "optional", "disabled", "class", "label-class"]));
  }
});
export {
  pe as default
};
